import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from 'react-i18next'

import {en} from './en'
import {ja} from './ja'

export type SupportedLanguages = 'en' | 'ja'
export const getSupportedLanguages = (): SupportedLanguages[] => ['en', 'ja']
export const languageLabels: Record<SupportedLanguages, string> = {en: 'EN', ja: 'JA'}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {en: {translation: en}, ja: {translation: ja}},
    fallbackLng: 'en',
    interpolation: {escapeValue: false},
    detection: {order: ['localStorage', 'navigator'], caches: ['localStorage']},
  })

export default i18n
